var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.513 15.48c-1.674 0-3.396-.119-4.08-.213-.307-.048-.472-.19-.425-.544l.282-1.815c.095-.52.26-.59.874-.543.59.047 2.312.188 3.302.188 2.17 0 3.067-.235 3.067-1.555 0-.898-.613-1.322-2.052-1.7l-1.746-.449C1.447 8.26.126 6.821.126 4.391.126 1.7 2.012.003 5.905.003c1.911 0 3.42.118 4.104.212.307.047.473.19.426.543l-.284 1.769c-.095.52-.259.59-.873.543a45.916 45.916 0 00-3.539-.165c-1.084 0-2.216.236-2.216 1.463 0 .872.542 1.25 1.721 1.556l1.747.449C10.105 7.175 11 8.708 11 10.76c0 3.491-2.737 4.718-6.488 4.718z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSIcon);
export default __webpack_public_path__ + "static/media/sIcon.5bc333f5.svg";
export { ForwardRef as ReactComponent };